// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TpH5s","icon":"styles_icon__AGc4a"};